<template>
  <el-container class="home_container">
    <el-header v-if="userInfo">
      <div class="home_title">我要租</div>
      <div class="home_userinfoContainer">
        <el-dropdown @command="logout">
          <span class="el-dropdown-link home_userinfo">
            {{ nickname }}<i class="el-icon-arrow-down el-icon--right home_userinfo"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px" v-if="userInfo">
        <el-menu
          unique-opened
          default-active="0"
          class="el-menu-vertical-demo" style="background-color: rgb(250, 250, 250)" router>
          <template v-for="(item,index) in routers" v-if="!item.hidden">
            <el-submenu :index="index+''" v-if="item.children.length>0" :key="index">
              <template slot="title">
                <i :class="item.iconCls" style="margin-right: 5px;"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item v-for="child in item.children" v-if="!child.hidden" :index="child.path" :key="child.path">
                {{ child.name }}
              </el-menu-item>
            </el-submenu>
            <template v-else>
              <el-menu-item :index="item.children[0].path">
                <i :class="item.children[0].iconCls"></i>
                <span slot="title">{{ item.children[0].name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main style="overflow-y: hidden;">
          <el-breadcrumb class="mb10" v-if="userInfo && this.$router.currentRoute.name == '首页'">
            <el-breadcrumb-item disabled>首页</el-breadcrumb-item>
          </el-breadcrumb>
          <el-breadcrumb class="mb10" separator-class="el-icon-arrow-right" v-if="userInfo && this.$router.currentRoute.name != '首页'">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-text="this.$router.currentRoute.name"></el-breadcrumb-item>
          </el-breadcrumb>
          <keep-alive>
            <router-view v-if="this.$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!this.$route.meta.keepAlive"></router-view>
          <div v-if="isAdmin">
            <div style="display: flex;justify-content: flex-start;">
              <el-date-picker v-if="this.$route.name == '首页' && show"
                              class="ml20"
                              v-model="month"
                              type="month"
                              placeholder="请选择月份"
                              value-format="yyyy-MM"
                              @change="getHomeStatisticData">
              </el-date-picker>
            </div>
            <div class="homeContainer" v-if="this.$route.name == '首页' && show">
              <!--统计页面-->
              <div class="left">
                <!---->
                <div class="card card-green">
                  <div class="card-title">
                    销售业绩总和(元)
                  </div>
                  <div class="card-number">
                    {{statisticData.saleTotal}}
                  </div>
                </div>
                <div class="card">
                  <div class="card-title">
                    公司业绩总和(元)
                  </div>
                  <div class="card-number">
                    {{statisticData.saleCompanyTotal}}
                  </div>
                </div>
                <div class="card">
                  <div class="card-title">
                    合作方业绩总和(元)
                  </div>
                  <div class="card-number">
                    {{statisticData.saleCooperateTotal}}
                  </div>
                </div>
                <div class="card">
                  <div class="card-title">
                    本月新签(单)
                  </div>
                  <div class="card-number">
                    {{statisticData.nowMonthSign}}
                  </div>
                </div>
                <div class="card">
                  <div class="card-title">
                    本月退租(单)
                  </div>
                  <div class="card-number">
                    {{statisticData.nowMonthBack}}
                  </div>
                </div>
                <div class="card">
                  <div class="card-title">
                    本月续签(单)
                  </div>
                  <div class="card-number">
                    {{statisticData.nowMonthContinue}}
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="right-top">
                  <div class="card-list">
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <div class="card-list-item empty">
                          <div class="card-number">
                            {{ statisticData.freeRate || '0%' }}
                          </div>
                          <div class="card-title">
                            空置率
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="card-list-item totalTao">
                          <div class="card-number">
                            {{ statisticData.houseTotal || 0 }}
                          </div>
                          <div class="card-title">
                            总套数
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="card-list-item totalJian">
                          <div class="card-number">
                            {{ statisticData.roomTotal || 0 }}
                          </div>
                          <div class="card-title">
                            总间数
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="card-list-item emptHouse">
                          <div class="card-number">
                            {{ statisticData.freeTotal || 0 }}
                          </div>
                          <div class="card-title">
                            空房数
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="right-main" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                  <!--本月收入统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        本月收入统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <!--本月已收房租-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月已收房租
                              </div>
                              <div class="collect-num" style="text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(0, statisticData.nowMonthCollectsData)">
                                {{statisticData.nowMonthCollects.length > 0 ? Math.ceil(statisticData.nowMonthCollects[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthCollects.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthCollects" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--本月收取违约金-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月收取违约金
                              </div>
                              <div class="collect-num" style="margin-left: 102px;text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(1, statisticData.nowMonthBreaksData)">
                                {{statisticData.nowMonthBreaks.length > 0 ? Math.ceil(statisticData.nowMonthBreaks[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthBreaks.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthBreaks" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--本月收取押金-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月收取押金
                              </div>
                              <div class="collect-num" style="text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(2, statisticData.nowMonthReceivesData)">
                                {{statisticData.nowMonthReceives.length > 0 ? Math.ceil(statisticData.nowMonthReceives[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthReceives.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthReceives" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--本月支出统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        本月支出统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <!--本月已交房租-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月已交房租
                              </div>
                              <div class="collect-num" style="text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(3, statisticData.nowMonthOutsData)">
                                {{statisticData.nowMonthOuts.length > 0 ? Math.ceil(statisticData.nowMonthOuts[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthOuts.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthOuts" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}交：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--本月退款押金-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月退款押金
                              </div>
                              <div class="collect-num" style="text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(4, statisticData.nowMonthDepositsData)">
                                {{statisticData.nowMonthDeposits.length > 0 ? Math.ceil(statisticData.nowMonthDeposits[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthDeposits.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthDeposits" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}退：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月支出中介费
                              </div>
                              <div class="collect-num" style="margin-left: 102px;text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(5, statisticData.nowMonthAgenciesData)">
                                {{statisticData.nowMonthAgencies.length > 0 ? Math.ceil(statisticData.nowMonthAgencies[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthAgencies.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthAgencies" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}出：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月支出押金
                              </div>
                              <div class="collect-num" style="margin-left: 102px;text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(6, statisticData.nowMonthFinishNeedOutsData)">
                                {{statisticData.nowMonthFinishNeedOuts.length > 0 ? Math.ceil(statisticData.nowMonthFinishNeedOuts[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthFinishNeedOuts.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthFinishNeedOuts" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}出：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--本月退款房租-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月退款房租
                              </div>
                              <div class="collect-num" style="text-decoration: #FE3B60 underline;cursor: pointer;" @click="openDetail(7, statisticData.nowMonthBackOutsData)">
                                {{statisticData.nowMonthBackOuts.length > 0 ? Math.ceil(statisticData.nowMonthBackOuts[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthBackOuts.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthBackOuts" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}退：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--本月房租统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        本月房租统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月应收房租
                              </div>
                              <div class="collect-num">
                                {{statisticData.nowMonthNeedCollects.length > 0 ? Math.ceil(statisticData.nowMonthNeedCollects[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthNeedCollects.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthNeedCollects" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                本月应交房租
                              </div>
                              <div class="collect-num">
                                {{statisticData.nowMonthNeedOuts.length > 0 ? Math.ceil(statisticData.nowMonthNeedOuts[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthNeedOuts.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthNeedOuts" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}交：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--次月房租统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        次月房租统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <!--次月应收房租-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                次月应收房租
                              </div>
                              <div class="collect-num">
                                {{statisticData.nextMonthCollects.length > 0 ? Math.ceil(statisticData.nextMonthCollects[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nextMonthCollects.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nextMonthCollects" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--次月应交房租-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                次月应交房租
                              </div>
                              <div class="collect-num">
                                {{statisticData.nextMonthOuts.length > 0 ? Math.ceil(statisticData.nextMonthOuts[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nextMonthOuts.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nextMonthOuts" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}交：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--日常支出统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        日常支出统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <!--日常支出统计-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                日常支出统计
                              </div>
                              <div class="collect-num">
                                {{statisticData.outFees.length > 0 ? Math.ceil(statisticData.outFees[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.outFees.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.outFees" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}支出：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--利润统计-->
                  <div class="main-card">
                    <div class="main-card-header">
                      <div class="main-card-header-icon">
                        <i class="el-icon-date"></i>
                      </div>
                      <div class="main-card-header-title">
                        利润统计
                      </div>
                    </div>
                    <div class="main-card-body">
                      <div class="house-statistic">
                        <div class="house-statistic-list">
                          <!--当月结算-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                当月结算
                              </div>
                              <div class="collect-num">
                                {{statisticData.nowMonthSettlements.length > 0 ? Math.ceil(statisticData.nowMonthSettlements[0].value) : 0}}
                              </div>
                            </div>
                            <div class="content" v-if="statisticData.nowMonthSettlements.length > 0">
                              <div class="collect-item" v-for="(item, index) in statisticData.nowMonthSettlements" :key="index" v-if="index > 0">
                                <div class="collect-item-name">
                                  {{item.name}}收：
                                </div>
                                <div class="collect-item-num">
                                  {{Math.ceil(item.value)}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--利润统计-->
                          <div class="house-statistic-list-item">
                            <div class="header">
                              <div class="dot">
                              </div>
                              <div class="house-title">
                                利润统计
                              </div>
                              <div class="collect-num" style="margin-left: 156px;">
                                {{statisticData.totalProfit ? Math.ceil(Math.ceil(statisticData.totalProfit)) : 0}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="margin-top: 200px;">
            <div class="index-container" v-if="this.$route.name == '首页'">
              <div class="index-background"/>
            </div>
            <div class="index-text" v-if="this.$route.name == '首页'">
              欢迎登录我要租后台系统
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="detailDialog.visible" :close-on-click-modal="false" width="80%"
               title="明细">
      <el-table v-show="detailDialog.type == 0" :data="detailDialog.collectRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="月租金" align="center"
                         prop="rent">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
            <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent / 3)}}</span>
            <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent / 6)}}</span>
            <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent / 12)}}</span>
            <span v-if="scope.row.payType == 4">{{Math.ceil(scope.row.rent / 2)}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="实收租金" align="center"
                         prop="rent"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">未收租</span>
            <span v-if="scope.row.state == 1">已收租</span>
            <span v-if="scope.row.state == 2">退租</span>
            <span v-if="scope.row.state == 3">未生效</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="应收租日期" align="center"
                         prop="needRentDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="实际收租日期" align="center"
                         prop="actualRentDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 1" :data="detailDialog.breakRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="退款房租" align="center"
                         prop="breakDeposit"></el-table-column>
        <el-table-column show-overflow-tooltip label="违约金/押金" align="center"
                         prop="breakRent"></el-table-column>
        <el-table-column show-overflow-tooltip label="时间" align="center"
                         prop="createDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="类型" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">正退</span>
            <span v-if="scope.row.state == 2">违退</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 2" :data="detailDialog.rentRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="小区" align="center"
                         prop="communityName"></el-table-column>
        <el-table-column show-overflow-tooltip label="房源" align="center"
                         prop="houseName"></el-table-column>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="签约类型" align="center" prop="oldRentRecordId">
          <template slot-scope="scope">
            <span v-if="scope.row.oldRentRecordId">续签</span>
            <span v-else>新签</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="付款方式" align="center"
                         prop="payType">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">月付</span>
            <span v-if="scope.row.payType == 4">两月付</span>
            <span v-if="scope.row.payType == 1">季付</span>
            <span v-if="scope.row.payType == 2">半年付</span>
            <span v-if="scope.row.payType == 3">年付</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">出租中</span>
            <span v-if="scope.row.state == 1">正退</span>
            <span v-if="scope.row.state == 2">违退</span>
            <span v-if="scope.row.state == 3">已结束</span>
            <span v-if="scope.row.state == 4">未生效</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="押金" align="center"
                         prop="deposit"></el-table-column>
        <el-table-column show-overflow-tooltip label="支出中介费" align="center"
                         prop="agencyFee"></el-table-column>
        <el-table-column show-overflow-tooltip label="租金" align="center"
                         prop="rent"></el-table-column>
        <el-table-column show-overflow-tooltip label="开始日期" align="center"
                         prop="startDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="结束日期" align="center"
                         prop="endDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="首次收租日期" align="center"
                         prop="firstRentDate" width="120"></el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 3" :data="detailDialog.collectRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房源名" align="center"
                         prop="houseName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="月租金" align="center"
                         prop="rent">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
            <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent / 3)}}</span>
            <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent / 6)}}</span>
            <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent / 12)}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="实付租金" align="center"
                         prop="rent"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">未交租</span>
            <span v-if="scope.row.state == 1">已交租</span>
            <span v-if="scope.row.state == 2">合同结束</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="应交租日期" align="center"
                         prop="needRentDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="实际交租日期" align="center"
                         prop="actualRentDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 4" :data="detailDialog.breakRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="退款房租" align="center"
                         prop="backRent"></el-table-column>
        <el-table-column show-overflow-tooltip label="违约金/押金" align="center"
                         prop="breakRent"></el-table-column>
        <el-table-column show-overflow-tooltip label="时间" align="center"
                         prop="createDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="类型" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">正退</span>
            <span v-if="scope.row.state == 2">违退</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 5" :data="detailDialog.agencyRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房源" align="center"
                         prop="houseName"></el-table-column>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="中介金" align="center"
                         prop="agencyFee"></el-table-column>
        <el-table-column show-overflow-tooltip label="时间" align="center"
                         prop="createDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 6" :data="detailDialog.rentRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="小区" align="center"
                         prop="communityName"></el-table-column>
        <el-table-column show-overflow-tooltip label="房源" align="center"
                         prop="houseName"></el-table-column>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="签约类型" align="center" prop="oldRentRecordId">
          <template slot-scope="scope">
            <span v-if="scope.row.oldRentRecordId">续签</span>
            <span v-else>新签</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="付款方式" align="center"
                         prop="payType">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">月付</span>
            <span v-if="scope.row.payType == 4">两月付</span>
            <span v-if="scope.row.payType == 1">季付</span>
            <span v-if="scope.row.payType == 2">半年付</span>
            <span v-if="scope.row.payType == 3">年付</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">出租中</span>
            <span v-if="scope.row.state == 1">正退</span>
            <span v-if="scope.row.state == 2">违退</span>
            <span v-if="scope.row.state == 3">已结束</span>
            <span v-if="scope.row.state == 4">未生效</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="押金" align="center"
                         prop="deposit"></el-table-column>
        <el-table-column show-overflow-tooltip label="支出中介费" align="center"
                         prop="agencyFee"></el-table-column>
        <el-table-column show-overflow-tooltip label="租金" align="center"
                         prop="rent"></el-table-column>
        <el-table-column show-overflow-tooltip label="开始日期" align="center"
                         prop="startDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="结束日期" align="center"
                         prop="endDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="首次收租日期" align="center"
                         prop="firstRentDate" width="120"></el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
      <el-table v-show="detailDialog.type == 7" :data="detailDialog.rentRecordData" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房间" align="center"
                         prop="roomName"></el-table-column>
        <el-table-column show-overflow-tooltip label="管理员" align="center"
                         prop="adminName"></el-table-column>
        <el-table-column show-overflow-tooltip label="退款房租" align="center"
                         prop="backRent">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="违约金/押金" align="center"
                         prop="deposit"></el-table-column>
        <el-table-column show-overflow-tooltip label="时间" align="center"
                         prop="createDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="类型" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">正退</span>
            <span v-if="scope.row.state == 2">违退</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center"
                         prop="description"></el-table-column>
      </el-table>
    </el-dialog>
  </el-container>
</template>
<script>


import {getPermissionMenus} from "@/api/menu";
import { getHomeStatisticData } from "@/api/house";

export default {
  data() {
    return {
      nickname: '',
      routers: [],
      userInfo: {},
      //首页统计数据
      statisticData: {},
      show: false,
      month: '',
      detailDialog: {
        visible: false,
        type: null,
        collectRecordData: [],
        breakRecordData: [],
        rentRecordData: [],
        agencyRecordData: [],
      },
      isAdmin: false
    }
  },
  mounted: function () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (!this.userInfo) {
      this.$router.push('/')
    } else {
      this.nickname = this.userInfo.nickname
      this.initMenu()
    }
    // 获取房源统计数据
    this.getHomeStatisticData();
    this.isAdmin = this.userInfo.roleIds.indexOf('1') != -1 || this.userInfo.roleIds.indexOf('2') != -1 || this.userInfo.roleIds.indexOf('4') != -1 || this.userInfo.roleIds.indexOf('5') != -1
  },
  methods: {
    openDetail(type, data) {
      this.detailDialog.type = null
      this.detailDialog.collectRecordData = []
      this.detailDialog.breakRecordData = []
      this.detailDialog.rentRecordData = []
      this.detailDialog.agencyRecordData = []
      this.detailDialog.type = type
      if (data) {
        if (type == 0 || type == 3) {
          this.detailDialog.collectRecordData = data
        } else if (type == 1 || type == 4) {
          this.detailDialog.breakRecordData = data
        } else if (type == 2 || type == 6 || type == 7) {
          this.detailDialog.rentRecordData = data
        } else if (type == 5) {
          this.detailDialog.agencyRecordData = data
        }
      }
      setTimeout(() => {
        this.detailDialog.visible = true
      }, 500)
    },
    // 初始化菜单
    initMenu() {
      let routers = JSON.parse(localStorage.getItem('routers'))
      const params = {
        roleIds: this.userInfo.roleIds
      }
      getPermissionMenus(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          const menus = response.data
          if (menus && menus.length > 0) {
            const startRoutes = routers.slice(0, 2);
            let endRoutes = routers.slice(2, routers.length + 1)
            const codes = menus.map(item => item.code)
            endRoutes = endRoutes.filter(item => codes.indexOf(item.code) != -1)
            // 修改名称和排序值
            for (const endRoute of endRoutes) {
              const menu = menus.filter(item => item.code == endRoute.code)[0]
              endRoute.name = menu.name
              endRoute.sort = menu.sort
            }
            endRoutes.sort(function (a, b) {
              return a.sort - b.sort
            })
            for (let endRoute of endRoutes) {
              endRoute.children = endRoute.children.filter(item => codes.indexOf(item.code) != -1)
              for (const child of endRoute.children) {
                const menu = menus.filter(item => item.code == child.code)[0]
                child.name = menu.name
                child.sort = menu.sort
              }
              endRoute.children.sort(function (a, b) {
                return a.sort - b.sort
              })
            }
            this.routers = startRoutes.concat(endRoutes)
          } else {
            this.routers = []
          }
        } else {
          this.routers = []
        }
      })
    },
    // 退出登录
    logout() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('退出登录成功')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('routers')
        localStorage.removeItem('token')
        this.$router.push('/')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    },
    // 获取首页统计数据
    getHomeStatisticData() {
      const params = {
        month: this.month
      }
      getHomeStatisticData(params).then(res => {
        this.statisticData = res.data || {}
        this.show = true
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.homeContainer {
  padding-top: 20px;
  display: flex;
  overflow: auto;
  height: calc(100vh - 154px);
  box-sizing: border-box;

  .left {
    width: 400px;
    height: fit-content;
    background: #FFFFFF;
    margin-bottom: 15px;
    box-shadow: 0px 0px 20px 0px rgba(51,51,51,0.06);
    border-radius: 10px;
    padding: 30px;
    .card {
      border-radius: 1px;
      padding: 40px 0 ;
      border: 1px dashed #E6E6E6;
      border-radius: 1px;
      &-title {
        color: #666666;
        padding: 0 30px 18px 30px;
      }
      &-number {
        padding: 0 30px;
        font-size: 40px;
        color: #333333;
      }
    }
    .card:not(:last-child) {
      margin-bottom: 30px;
    }
    .card.card-green {
      border: none;
      background: #00B8A5;
      .card-title {
        color: #FFFFFF;
      }
      .card-number {
        color: #FFFFFF;
        font-size: 50px;
      }
    }
  }
  .right {
    flex: 1;
    margin: 0 20px;
    &-top {
      .card-list {
        &-item {
          height: 100px;
          padding: 0 28px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          border-radius: 6px;
          .card-number{
            font-size: 36px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
          }
          .card-title{
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
          }


        }
        &-item.emptHouse{
          background: url("../../assets/emptHouse.png") no-repeat;
          background-size: cover;
        }
        &-item.empty{
          background: url("../../assets/empty.png") no-repeat;
          background-size: cover;
        }
        &-item.totalJian{
          background: url("../../assets/totalJian.png") no-repeat;
          background-size: cover;
        }
        &-item.totalTao{
          background: url("../../assets/totalTao.png") no-repeat;
          background-size: cover;
        }
      }
    }
    &-main {
      padding-bottom: 20px;
      .main-card {
        // height: 340px;
        width: 605px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(51,51,51,0.06);
        border-radius: 10px;
        margin-top: 20px;
        padding: 24px 30px;
        box-sizing: border-box;
        &-header {
          display: flex;
          align-items: center;
          &-icon {
            i {
              color: green;
              vertical-align: middle;
            }
          }
          &-title {
            margin-left: 8px;
            font-size: 20px;
          }
        }
        &-body {
          .house-statistic {
            &-list {
              margin-top: 20px;
              &-item {
                .header {
                  display: flex;
                  align-items: center;
                  margin-bottom: 8px;
                  .dot {
                    width: 6px;
                    height: 6px;
                    background: #1BA784;
                    border-radius: 50%;
                  }
                  .house-title {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    margin-left: 14px;
                  }
                  .collect-num {
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FE3B60;
                    margin-left: 120px;
                  }
                }
                .content {
                  background: #F9F9F9;
                  margin: 15px 0;
                  padding: 15px;
                  .collect-item {
                    display: flex;
                    align-items: center;
                    &-name {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #666666;
                    }
                    &-num {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #666666;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.home_container {
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

.el-header {
  background-color: #004ce5;
  color: #333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-aside {
  background-color: rgb(250, 250, 250);
}

.el-menu {
  height: 100%;
}

.el-main {
  background-color: #fff;
  color: #000;
  text-align: center;
}

.home_title {
  color: #fff;
  font-size: 22px;
  display: inline;
}

.home_userinfo {
  color: #fff;
  cursor: pointer;
}

.home_userinfoContainer {
  display: inline;
  margin-right: 20px;
}

.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;
}

.index-background {
  background-image: url('../../public/img/index.png');
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  height: 400px;
  width: 300px;
}

.index-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bolder;
}

.el-submenu__title {
  padding-left: 0 !important;
}

.index-container {
  width: 100%;
  min-height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue